var _g, _g2, _path, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenFbk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 240,
    viewBox: "0 0 158.75 63.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -233.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.73 85.623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-166.91 -38.038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m100.17 207.97c-3.575 0-6.4534 2.8783-6.4534 6.4534 0 1.5105 0.51512 2.8954 1.3782 3.9925-0.2436 1.1248-0.98406 2.832-3.0468 5.0488 3.6299-1.0283 5.9294-2.1441 6.9489-2.6959 0.38039 0.0693 0.77206 0.10747 1.1731 0.10747h10.394c3.575 0 6.4534-2.8778 6.4534-6.4528 0-3.575-2.8784-6.4534-6.4534-6.4534zm0.37517 4.8653a1.5875 1.5875 0 0 1 1.5875 1.5875 1.5875 1.5875 0 0 1-1.5875 1.5875 1.5875 1.5875 0 0 1-1.5875-1.5875 1.5875 1.5875 0 0 1 1.5875-1.5875zm4.8214 0a1.5875 1.5875 0 0 1 1.5875 1.5875 1.5875 1.5875 0 0 1-1.5875 1.5875 1.5875 1.5875 0 0 1-1.5875-1.5875 1.5875 1.5875 0 0 1 1.5875-1.5875zm4.8219 0a1.5875 1.5875 0 0 1 1.5875 1.5875 1.5875 1.5875 0 0 1-1.5875 1.5875 1.5875 1.5875 0 0 1-1.5875-1.5875 1.5875 1.5875 0 0 1 1.5875-1.5875z",
    fill: "#e37575",
    fillRule: "evenodd",
    style: {
      paintOrder: "normal"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4139 0 0 2.4139 117.78 191.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    fill: "#5d6ad8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99957 0 0 .99957 72.315 212.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
    fill: "#dd5858"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 167.69,
    y: 197.9,
    width: 49.138,
    height: 18.391,
    ry: 9.1957,
    fill: "#868fe2",
    fillRule: "evenodd",
    style: {
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m165 221.42c7.6296-7.4485 6.011-11.685 6.011-11.685l8.7412 6.2863s-4.9075 2.865-14.752 5.3986z",
    fill: "#868fe2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 174.9 203.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#252f8c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 181.99 203.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#252f8c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 189.09 203.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#252f8c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 196.18 203.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#e6e8f8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 203.28 203.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,17.27 18.18,21 16.54,13.97 22,9.24 14.81,8.63 12,2 9.19,8.63 2,9.24 7.46,13.97 5.82,21 Z",
    fill: "#e6e8f8"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenFbk);
export default __webpack_public_path__ + "static/media/gen-fbk.e41488866cde1abb2651174e5e21c048.svg";
export { ForwardRef as ReactComponent };